const routes = [
    {
        path: "/route-permission-list",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "system_routepermissionlist"
        }
    }
]

export default routes;
